export default __webpack_public_path__ + "static/media/tarjetas.3cc548b2.png";